import React from 'react';
import EmailSvg from '../../assets/icons/Email.svg';
import { Typography, Button, Box } from '@mui/material';

type Props = {
  onNavigate: () => void;
  bodyText: string;
  resendEmailVerification: () => void;
};

const CheckEmail = ({
  onNavigate,
  bodyText,
  resendEmailVerification,
}: Props) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'flex-start'}
      gap={2}
    >
      <img
        src={EmailSvg}
        style={{
          width: '74px',
          height: '74px',
        }}
        alt="test"
      />

      <Typography variant="h3" className="login_form_info--text">
        Please check your email!
      </Typography>
      <Typography
        style={{
          color: '#5D6E82',
        }}
      >
        {bodyText}
      </Typography>

      <Button
        onClick={onNavigate}
        variant="contained"
        style={{
          backgroundColor: '#2A7BE4',
          padding: '7px 13px',
          fontSize: '13px',
        }}
      >
        {'<'} Return to Login
      </Button>

      <Button
        onClick={resendEmailVerification}
        variant="text"
        sx={{
          backgroundColor: 'transparent',
          padding: '2px 4px',
          fontSize: '13px',
          color: '#696969',
          '&:hover': {
            backgroundColor: 'transparent',
            color: '#3f3f3f',
          },
        }}
      >
        Resend verification email
      </Button>
    </Box>
  );
};

export default CheckEmail;
